/** 句末标点：中英文终止符、换行、分号 */
export const SENTENCE_END_REGEX = /[。！？!?\n；;]/
/** 句子最小长度（UTF-16 单元，与后端 cleanText 计费 length 口径一致） */
export const DEFAULT_MIN_SENTENCE_LEN = 15

/**
 * 从 buffer 中切出「已稳定」的句子：遇句末标点且累计 ≥ minLen 才输出；
 * 不足 minLen 的片段累计合并，留 remaining 等下一次再判。
 *
 * 流式文本单调追加（reducer.appendText 只追加不改前文），故已切出的句子文本不会回改，安全。
 * 流式结束时，调用方应把 remaining 整体作为一个段送合成（见 store.prefetchFlush）。
 */
export function drainStableSentences(
  buffer: string,
  minLen = DEFAULT_MIN_SENTENCE_LEN,
): { sentences: string[]; remaining: string } {
  const sentences: string[] = []
  let lastCut = 0 // 上次确认输出的切点
  for (let i = 0; i < buffer.length; i++) {
    if (!SENTENCE_END_REGEX.test(buffer[i])) {
      continue
    }
    const candidate = buffer.slice(lastCut, i + 1)
    if (candidate.length >= minLen) {
      sentences.push(candidate)
      lastCut = i + 1
    }
    // < minLen 不切，lastCut 不动 → 与后续文本合并再判
  }
  return { sentences, remaining: buffer.slice(lastCut) }
}

/** 静态兜底播放的句长下限：历史播放无抢首句需求，段长放大换请求数下降（3000 字 ≈ 13-25 段） */
export const STATIC_MIN_SENTENCE_LEN = 120
/** 段长硬上限：< 后端 CHUNK_CHARS(280) → 每请求恰一次 DashScope 调用；无标点长块（裸 JSON）按此硬切 */
export const MAX_SEGMENT_CHARS = 240

/**
 * 静态全文切分（历史消息兜底播放，非流式）：复用 drainStableSentences 的句末规则，
 * 段长 120~240；尾部残留（无句末标点结尾）整体作末段，超长再按 MAX_SEGMENT_CHARS 硬切。
 */
export function splitStaticText(text: string): string[] {
  const { sentences, remaining } = drainStableSentences(text, STATIC_MIN_SENTENCE_LEN)
  const pieces = remaining.trim() ? [...sentences, remaining.trim()] : sentences
  const out: string[] = []
  for (const piece of pieces) {
    for (let i = 0; i < piece.length; i += MAX_SEGMENT_CHARS) {
      out.push(piece.slice(i, i + MAX_SEGMENT_CHARS))
    }
  }
  return out
}
